<div class="container">

  <div class="loader" *ngIf="loading"></div>

  <div *ngIf="mode == 'EDIT' && !loading" class="animated fadeIn">
    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top">
      <div class="container">
        <span class="navbar-text">
          Registro Horas
        </span>
        <div class="pull-right">
          <button class="btn btn-secondary me-1" *ngIf="model.id" data-bs-toggle="modal" data-bs-target="#loadFile" title="Cargar comprobantes">
            <span class="fa fa-upload fa-lg "></span>
          </button>
          <button class="btn btn-secondary me-1" (click)="cancelEvent()">
            Cerrar
          </button>
          <button class="btn btn-primary" (click)="saveEvent()">
            Guardar
          </button>
        </div>
      </div>
    </nav>

    <div class="row" *ngIf="absencesByDate != undefined && absencesByDate.length > 0">
      <ul class="list-group p-3">

        <li class="list-group-item list-group-item-warning" *ngFor="let absense of  absencesByDate">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1" *ngIf="absense.type == 'MEDICAL_DISABILITY'">Ausencia por Incapacidad</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'PAID_VACATION'">Ausencia por Vacaciones pagas</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'UNPAID_VACATION'">Ausencia por Vacaciones no pagas</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'PAID_LEAVING'">Permiso con goce de salario</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'UNPAID_LEAVING'">Permiso sin goce de salario</h5>
            <h5 class="mb-1" *ngIf="absense.type == 'OTHER'">Ausencia</h5>
            <small class="text-body-secondary">{{absense.hours}} hora(s)</small>
          </div>
          <p class="mb-1">Se registró una ausencia para la fecha y empleado seleccionado, en caso que la ausencia sea por el total de horas laboradas no es necesario registrarlas.</p>
          <small class="text-body-secondary">Detalles: {{absense.details ? absense.details : '[Sin Detalles]'}}</small>
        </li>
      </ul>
    </div>

    <div class="row g-3">
      <div class="col-md-3">
        <div class="form-group">
          <label for="date">Fecha</label>
          <mt-date-picker [(date)]="model.date" name="date" id="date" label="Fecha" (dateChange)="fetchAbsencesEvent()"/>
          <div *ngIf="formErrors.get('workdaylog.date')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('workdaylog.date') }}
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="employee">Empleado</label>
          <select class="form-select" id="employee" name="employee" [(ngModel)]="model.employee"  (ngModelChange)="fetchAbsencesEvent()">
            <option [ngValue]="undefined">Seleccione...</option>
            <option *ngFor="let employee of employees" [ngValue]="employee.id" [class.text-danger]="employee.archived">{{employee.name}} {{employee.lastName}} {{employee.archived? ' (Archivado)' : ''}}</option>
          </select>
          <div *ngIf="formErrors.get('workdaylog.employee')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('workdaylog.employee') }}
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="workedHours">Horas Trabajadas</label>
          <mt-time-picker [(time)]="model.workedHours" name="workedHours" label="Horas Trabajadas" id="workedHours" [meridian]="false"/>
          <div *ngIf="formErrors.get('workdaylog.workedHours')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('workdaylog.workedHours') }}
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="acceptedHours">Horas Aceptadas</label>
          <mt-time-picker [(time)]="model.acceptedHours" name="acceptedHours" label="Horas Aceptadas" id="acceptedHours" [meridian]="false"/>
          <div *ngIf="formErrors.get('workdaylog.acceptedHours')" class="badge bg-danger animated fadeIn">
            {{ formErrors.get('workdaylog.acceptedHours') }}
          </div>
        </div>
      </div>
    </div>
    <h5  class="mb-3 mt-3">Horas Ingreso/Salida</h5>
    <hr class="mb-4">
    <button class="btn btn-secondary" (click)="addEntryEvent()">
      Agregar
    </button>
    <table *ngIf="model.workdayLogEntries.length > 0" class="table table-hover">
      <tbody>
      <tr *ngFor="let entry of model.workdayLogEntries; let i = index;">
        <td class="align-middle">
          <mt-time-picker [(time)]="entry.time" name="startTime" label="Hora"/>
        </td>

        <td class="text-end  align-middle">
          <button class="btn  pull-right btn-info me-2" (click)="removeEntryEvent(i)" title="Remover Registro">
            <span class="fa fa-trash fa-lg"></span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div *ngIf="model.workdayLogEntries.length == 0" class="p-3">
      No hay registros
    </div>

    <div class="mb-3 card">
      <h5 class="card-header">
        Comprobantes
      </h5>
      <div class="card-body">
        <table *ngIf="attachments != undefined && attachments.length > 0" class="table table-hover">
          <thead>
          <tr>
            <td>Archivo</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let attachment of attachments; let i = index">
            <td class="mt-content-col align-middle">
              <span [title]="attachment.name">{{attachment.name}}</span>
            </td>
            <td class="mt-actions-col">
              <button class="btn btn-secondary pull-right  me-1" (click)="downloadAttachment(attachment.id, attachment.name)" title="Descargar">
                <span class="fa fa-download fa-lg"></span>
              </button>
              <button class="btn btn-warning pull-right"(click)="selectedAttachment = attachment" data-bs-toggle="modal" data-bs-target="#removeAttachmentConfirmation" title="Remover">
                <span class="fa fa-trash fa-lg"></span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div *ngIf="attachments == undefined || attachments.length == 0" class="p-3">
          No hay comprobantes adjuntos
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="mode == 'LIST' && !loading" class="animated fadeIn">

    <nav class="navbar navbar-light bg-light fixed-top mt-fixed-top shadow-sm">

        <div class="container-fluid">
          <form class="d-flex">
              <mt-date-picker [(date)]="from" label="Desde" class="me-2" (dateChange)="fromDateChanged()"/>

              <mt-date-picker [(date)]="to" label="Hasta" class="me-2" (dateChange)="toDateChanged()"/>

              <div>
                <select class="form-select me-2" id="type" name="type" [(ngModel)]="employeeId" (ngModelChange)="refreshEvent()" title="Empleado">
                  <option [ngValue]="-1">Todos</option>
                  <option *ngFor="let employee of employees" [ngValue]="employee.id" [class.text-danger]="employee.archived">{{ employee.name }}  {{employee.lastName}} {{employee.archived? ' (Archivado)' : ''}}</option>
                </select>
              </div>
          </form>
          <div class="pull-right">
            <button class="btn btn-secondary me-1" data-bs-toggle="modal" data-bs-target="#importFile" title="Importar bitácoras">
              <span class="fa fa-upload fa-lg "></span>
            </button>
            <button class="btn btn-secondary me-1" data-bs-toggle="modal" data-bs-target="#generateMissingConfirmation" title="Generar registros faltantes">
              <span class="fa-solid fa-wand-magic-sparkles"></span>
            </button>
            <button class="btn btn-link" (click)="refreshEvent()" title="Refrescar">
              <span class="fa fa-sync fa-lg"></span>
            </button>
            <button class="btn btn-danger me-1" data-bs-toggle="modal" data-bs-target="#workdayLogBulkConfirmation" [disabled]="countSelections === 0" title="Borrar Seleccionados">
              Borrar
            </button>
            <button class="btn btn-primary" (click)="createEvent()">
              Agregar
            </button>
          </div>
        </div>


    </nav>

    <mt-pagination (loadPage)="getPageEvent($event)" [page]="page"></mt-pagination>

    <table *ngIf="page.metadata.pages > 0" class="table table-hover">
      <thead>
        <tr>
          <th class="text-center" style="width: 40px;">
            <input type="checkbox" [(ngModel)]="allSelected" (ngModelChange)="changeSelection($event)"/>
          </th>
          <th>
            Fecha
          </th>
          <th>
            Horas Trabajadas
          </th>
          <th>
            Horas Aprobadas
          </th>
          <th>
            Empleado
          </th>
          <th>

          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let workday of page.content">
          <td class="text-center">
            <input type="checkbox" [(ngModel)]="workday.selected" (ngModelChange)="changeSingleSelection($event)" (click)="$event.stopPropagation()"/>
          </td>
          <td (click)="editEvent(workday)" class="mt-content-col">
            {{workday.date}}
          </td>
          <td (click)="editEvent(workday)" class="mt-content-col">
            {{workday.workedHours}}
          </td>
          <td (click)="editEvent(workday)" class="mt-content-col">
            {{workday.acceptedHours}}
          </td>
          <td (click)="editEvent(workday)" class="mt-content-col" [class.text-danger]="workday.employeeArchived">
            {{workday.employeeName}} {{workday.employeeArchived? ' (Archivado)' : ''}}
          </td>
          <td class="mt-actions-col">
            <button class="btn btn-link btn-lg pull-right" data-bs-toggle="modal" data-bs-target="#workdayLogConfirmation"
                    (click)="selectEvent(workday)" title="Borrar">
              <span class="fa fa-trash-alt fa-lg"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="page.metadata.pages == 0">
      No hay registros
    </div>

  </div>

  <!-- Modal -->
  <div class="modal fade" id="workdayLogConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el registro?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeEvent(model)">Borrar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="loadFile" tabindex="-1" role="dialog"
       aria-labelledby="loadFileLabel">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Cargar Archivo</h5>
        </div>
        <div class="modal-body">
          <p *ngIf="loading">Cargando archivo...</p>
          <p *ngIf="fileUploadErrors.length == 0 && !loading">Seleccione los comprobantes que desea utilizar para justificar las horas extra.</p>

          <input type="file" #fileUpload id="fileUpload" name="fileUpload" (change)="onFileSelected($event)" multiple="multiple" style="display:none;" />
          <ul *ngIf="fileUploadErrors.length > 0 && !loading" class="list-group list-group-flush">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Errores encontrados
              <span class="badge bg-danger bg-pill">{{fileUploadErrors.length}}</span>
            </li>
            <li *ngFor="let error of fileUploadErrors" class="list-group-item">
              <span>Línea {{error.line}}</span> <br> <small>{{error.message}}</small>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" (click)="fileUpload.click()" title="Seleccionar..." [disabled]="loading">
            Seleccionar...
          </button>
          <button type="button" class="btn btn-link" data-bs-dismiss="modal" (click)="cleanData()" [disabled]="loading">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="importFile" tabindex="-1" role="dialog"
       aria-labelledby="importFileLabel">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Importar Bitácora</h5>
        </div>
        <div class="modal-body">
          <p *ngIf="loading">Cargando archivo...</p>
          <p *ngIf="fileUploadErrors.length == 0 && !loading">Seleccione la bitácora de registro de horas que desea importar.</p>

          <input type="file" #fileImportUpload id="fileImportUpload" name="fileImportUpload" (change)="onImportFileSelected($event)" multiple="multiple" style="display:none;" />
          <ul *ngIf="fileUploadErrors.length > 0 && !loading" class="list-group list-group-flush">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              Errores encontrados
              <span class="badge bg-danger bg-pill">{{fileUploadErrors.length}}</span>
            </li>
            <li *ngFor="let error of fileUploadErrors" class="list-group-item">
              <span>Línea {{error.line}}</span> <br> <small>{{error.message}}</small>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" (click)="fileImportUpload.click()" title="Seleccionar..." [disabled]="loading">
            Seleccionar...
          </button>
          <button type="button" class="btn btn-link" data-bs-dismiss="modal" (click)="cleanData()" [disabled]="loading">Cerrar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="generateMissingConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="generateMissingConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Se generarán registros faltantes según el rango y filtros actuales.</p>
          <p class="mb-1"><strong>Rango:</strong> {{from}} → {{to}}</p>
          <p class="mb-0">
            <strong>Empleado(s):</strong>
            <ng-container *ngIf="employeeId !== -1; else currentFilters">
              {{ getSelectedEmployee()?.name }} {{ getSelectedEmployee()?.lastName }}
            </ng-container>
            <ng-template #currentFilters>Todos</ng-template>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="generateMissingEvent()" [disabled]="loading">Generar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="removeAttachmentConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar el comprobante {{selectedAttachment?.name}}?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="removeAttachment(selectedAttachment?.id)">Borrar</button>
        </div>
      </div>
    </div>
  </div>

</div>

  <div class="modal fade" id="workdayLogBulkConfirmation" tabindex="-1" role="dialog"
       aria-labelledby="removeBulkConfirmationLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Desea eliminar los registros seleccionados?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="deleteSelectedEvent()">Borrar</button>
        </div>
      </div>
    </div>
  </div>
